import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setArticle,
  setCourse,
  setCourses,
} from '@/redux/courses/coursesSlice';

import coursesService from '@/services/coursesService';

const getCourses = () => async dispatch => {
  try {
    const response = await coursesService.getCourses();
    const {
      data: { items },
    } = response;

    dispatch(setCourses(items));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetCourses failure');
  }
};

const getCourse = id => async dispatch => {
  try {
    const response = await coursesService.getCourse(id);
    const { data } = response;

    dispatch(setCourse(data));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetCourse failure');
  }
};

const getArticle = id => async dispatch => {
  try {
    const response = await coursesService.getArticle(id);
    const { data } = response;

    dispatch(setArticle(data));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetArticle failure');
  }
};

export default {
  getCourses,
  getCourse,
  getArticle,
};
